import { ref, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format, subDays } from 'date-fns'
import {
  formatDateTimeDDMMYYHHMM, maskHiddenCpf2,
} from '@core/utils/utils'

export default function useNeedValidatePhysicianList() {
  // Use toast
  const toast = useToast()

  const refPhysicianListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'name', sortable: true, sortKey: 'name', label: 'Profissional',
    },
    { key: 'profession.label', label: 'Profissão', sortable: false },
    { key: 'cpf', sortable: true },
    { key: 'crm', sortable: true },
    { key: 'institution', label: 'Instituição', sortable: false },
    { key: 'motive_need_validate_manually', label: 'Motivo', sortable: false },
    {
      key: 'created_at',
      label: 'Criado',
      sortable: false,
      formatter: v => formatDateTimeDDMMYYHHMM(new Date(v)),
    },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(25)
  const totalPhysicians = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('name')
  const isSortDirDesc = ref(true)

  const beginDate = ref(format(subDays(new Date(), 5), 'yyyy-MM-dd'))
  const endDate = ref(format(new Date(), 'yyyy-MM-dd'))
  const institutionId = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refPhysicianListTable.value ? refPhysicianListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPhysicians.value,
    }
  })

  const refetchData = () => {
    refPhysicianListTable.value.refresh()
  }

  const getReportParams = () => ({
    institution: institutionId.value ? institutionId.value.value : '',
    begin: beginDate.value,
    end: endDate.value,
    perPage: perPage.value,
    page: currentPage.value,
    sortBy: sortBy.value,
    sortDirection: isSortDirDesc.value ? 'desc' : 'asc',
  })

  const fetchPhysicians = (ctx, callback) => {
    store
      .dispatch('app-physician/fetchReportNeedValidatePhysicians', getReportParams())
      .then(response => {
        const { data: physicians } = response.data
        const physicianList = physicians.map(physician => {
          const p = { ...physician, status: 'active' }
          p.cpf = maskHiddenCpf2(p.cpf)
          return p
        })
        callback(physicianList)
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao buscar',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    fetchPhysicians,
    tableColumns,
    perPage,
    currentPage,
    totalPhysicians,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPhysicianListTable,

    refetchData,

    // Extra Filters
    institutionId,
    beginDate,
    endDate,
  }
}
